import { DateTime } from 'luxon';

export interface OrganisationJson {
    id: number;
    public_id: string;
    name: string;
    logo: string | null;
    base_currency?: string | null;
    vat_number?: string | null;
    company_registration_number?: string | null;
    registered_office_address?: string | null;
    created_at: string;
    updated_at: string;
    oldest_order_date: string | null;
}

export class Organisation {
    id = 0;
    public_id = 'unknown';
    name = 'Unknown';
    logo: string | null = null;
    base_currency: string | null = null;
    vat_number: string | null = null;
    company_registration_number: string | null = null;
    registered_office_address: string | null = null;
    created_at: DateTime = DateTime.now();
    updated_at: DateTime = DateTime.now();
    oldestOrderDate: DateTime | null = null;
    role?: string;

    static fromJSON(json: OrganisationJson): Organisation {
        //console.debug("Organisation.fromJSON()", json);
        const user = Object.create(Organisation.prototype);
        return Object.assign(user, json, {
            created_at: json.created_at ? DateTime.fromISO(json.created_at) : DateTime.now(),
            updated_at: json.updated_at ? DateTime.fromISO(json.updated_at) : DateTime.now(),
            oldestOrderDate: json.oldest_order_date ? DateTime.fromISO(json.oldest_order_date) : null,
        });
    }
}
